import Vue from 'vue'
import store from '~/store'
Vue.prototype.$can = permiso => {
    if(store.getters['auth/obtenerUsuario'].super_admin === 1) return true
    if(permiso === undefined) return true
    if(store.getters['auth/obtenerUsuario'].permisos.some(a=> a === permiso)) return true
    return false
}
